/* Testbed theme — behaviour. No dependencies. */
(function () {
  'use strict';

  var routes = (window.themeRoutes || {});
  var money = window.themeMoneyFormat || '${{amount}}';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDecimals = parts.join('.');
    var noDecimals = parts[0];
    return money
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
  }

  /* ---------------- Overlay / drawers ---------------- */

  var overlay = $('[data-overlay]');

  function openPanel(el) {
    if (!el) return;
    el.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeAllPanels() {
    $$('.is-open[data-panel]').forEach(function (p) { p.classList.remove('is-open'); });
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  on(overlay, 'click', closeAllPanels);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllPanels(); });
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openPanel($('#' + opener.getAttribute('data-open'))); return; }
    if (e.target.closest('[data-close-panel]')) { e.preventDefault(); closeAllPanels(); }
  });

  /* ---------------- Announcement rotator ---------------- */

  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var speed = parseInt(bar.getAttribute('data-speed'), 10) || 4;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed * 1000);
  });

  /* ---------------- Accordions (FAQ + collapsible rows) ---------------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-accordion-toggle]');
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    if (panel) panel.classList.toggle('is-open', !open);
  });

  /* ---------------- Product gallery ---------------- */

  $$('[data-gallery]').forEach(function (gallery) {
    var slides = $$('.gallery__slide', gallery);
    var thumbs = $$('.gallery__thumb', gallery);
    if (!slides.length) return;
    var index = 0;

    function go(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    }

    thumbs.forEach(function (t, i) { on(t, 'click', function () { go(i); }); });
    on($('[data-gallery-prev]', gallery), 'click', function () { go(index - 1); });
    on($('[data-gallery-next]', gallery), 'click', function () { go(index + 1); });

    // Jump to the first media matching a variant's featured image
    gallery.addEventListener('theme:variant', function (e) {
      var id = e.detail && e.detail.mediaId;
      if (!id) return;
      var target = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(id); });
      if (target > -1) go(target);
    });

    // Swipe on touch devices
    var startX = null;
    gallery.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 45) go(dx < 0 ? index + 1 : index - 1);
      startX = null;
    });
  });

  /* ---------------- Variant selection ---------------- */

  $$('.product-form').forEach(function (form) {
    var root = form.closest('[data-product-root]') || document;
    var dataEl = $('[data-variants-json]', root);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = $('[data-variant-id]', form);
    var submit = $('[data-add-button]', form);
    var priceEl = $('[data-price-block]', root);
    var gallery = $('[data-gallery]', root);

    function currentOptions() {
      var opts = [];
      $$('[data-option-index]', root).forEach(function (el) {
        var i = parseInt(el.getAttribute('data-option-index'), 10);
        if (el.type === 'radio') { if (el.checked) opts[i] = el.value; }
        else { opts[i] = el.value; }
      });
      return opts;
    }

    function match(opts) {
  if (!opts.length && variants.length === 1) {
    return variants[0];
  }

  return variants.find(function (v) {
    return v.options.every(function (o, i) {
      return o === opts[i];
    });
  });
}

    function renderPrice(v) {
      if (!priceEl || !v) return;
      var html = '<span class="price__current">' + formatMoney(v.price) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var save = Math.round((1 - v.price / v.compare_at_price) * 100);
        html += '<s class="price__was">' + formatMoney(v.compare_at_price) + '</s>';
        html += '<span class="price__save">Save ' + save + '%</span>';
      }
      priceEl.innerHTML = html;
    }

    function update() {
      var v = match(currentOptions());
      if (!v) {
        if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? (submit.getAttribute('data-add-text') || 'Add to cart') : 'Sold out';
      }
      renderPrice(v);
      if (gallery && v.featured_media && v.featured_media.id) {
        gallery.dispatchEvent(new CustomEvent('theme:variant', { detail: { mediaId: v.featured_media.id } }));
      }
      // Reflect in sticky bar
      var sticky = $('[data-sticky-price]');
      if (sticky) sticky.textContent = formatMoney(v.price);
      if (history.replaceState && v.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-option-index]', root).forEach(function (el) { on(el, 'change', update); });
    update();
  });

  /* ---------------- Quantity tiers ---------------- */

  function setQuantity(value) {
    var form = document.querySelector('.product-form');
    if (form) {
      var field = $('[data-quantity-input]', form);
      if (field) field.value = value;
    }
    var proxy = $('[data-quantity-proxy]');
    if (proxy) proxy.value = value;
  }

  $$('[data-tiers]').forEach(function (group) {
    group.addEventListener('change', function (e) {
      var input = e.target.closest('input[data-tier-qty]');
      if (!input) return;
      setQuantity(input.getAttribute('data-tier-qty'));
    });
  });

  // Visible stepper writes through to the hidden quantity field
  document.addEventListener('change', function (e) {
    var proxy = e.target.closest('[data-quantity-proxy]');
    if (!proxy) return;
    var form = document.querySelector('.product-form');
    if (!form) return;
    var field = $('[data-quantity-input]', form);
    if (field) field.value = Math.max(1, parseInt(proxy.value, 10) || 1);
  });

  /* ---------------- Quantity steppers ---------------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.qty');
    var input = $('input', wrap);
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Cart ---------------- */

  function refreshCartUI(cart) {
    var count = $('[data-cart-count]');
    if (count) {
      count.textContent = cart.item_count;
      count.hidden = cart.item_count === 0;
    }
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    fetch(routes.cart_url + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-cart-drawer-contents]', doc);
        var target = $('[data-cart-drawer-contents]', drawer);
        if (fresh && target) target.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* fall back to a full reload on the next navigation */ });
  }

  function addToCart(form, button) {
    var original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }

    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || 'Could not add to cart');
        return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        refreshCartUI(cart);
        if (window.themeCartType === 'drawer') openPanel($('[data-cart-drawer]'));
        else window.location.href = routes.cart_url;
      })
      .catch(function (err) { alert(err.message); })
      .finally(function () { if (button) { button.disabled = false; button.textContent = original; } });
  }
  function addUpsellToCart(button) {
    if (!button) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var original = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding…';

    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1
          }
        ]
      })
    })
      .then(function (r) {
        return r.json().then(function (body) {
          return { ok: r.ok, body: body };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          throw new Error(
            res.body.description ||
            res.body.message ||
            'Could not add this item to cart'
          );
        }

        return fetch(routes.cart_url + '.js')
          .then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        refreshCartUI(cart);
        openPanel($('[data-cart-drawer]'));
      })
      .catch(function (err) {
        alert(err.message);
        button.disabled = false;
        button.textContent = original;
      });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest('[data-cart-upsell-add]');
    if (!button) return;

    e.preventDefault();
    addUpsellToCart(button);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.product-form');
    if (!form) return;
    e.preventDefault();
    addToCart(form, $('[data-add-button]', form));
  });

  function changeLine(key, quantity) {
    fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        refreshCartUI(cart);
      });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); changeLine(remove.getAttribute('data-cart-remove'), 0); }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-cart-qty'), parseInt(input.value, 10));
  });

  /* ---------------- Sticky add to cart ---------------- */

  var stickyBar = $('[data-sticky-atc]');
  var mainForm = $('.product-form');
  if (stickyBar && mainForm) {
    var sentinel = $('[data-atc-sentinel]') || mainForm;
    var io = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(sentinel);

    on($('[data-sticky-add]', stickyBar), 'click', function () {
      addToCart(mainForm, $('[data-sticky-add]', stickyBar));
    });
  }

  /* ---------------- Stats count-up ---------------- */

  var statEls = $$('[data-count-to]');
  if (statEls.length && 'IntersectionObserver' in window) {
    var statObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-count-to')) || 0;
        var suffix = el.getAttribute('data-count-suffix') || '';
        var prefix = el.getAttribute('data-count-prefix') || '';
        var decimals = (String(target).split('.')[1] || '').length;
        var start = performance.now();
        var duration = 1400;
        (function step(now) {
          var p = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
          if (p < 1) requestAnimationFrame(step);
        })(start);
        obs.unobserve(el);
      });
    }, { threshold: 0.4 });
    statEls.forEach(function (el) { statObserver.observe(el); });
  }

  /* ---------------- Marquee duplication (seamless loop) ---------------- */

  $$('[data-marquee]').forEach(function (track) {
    track.innerHTML = track.innerHTML + track.innerHTML;
  });

  /* ---------------- Video lazy load ---------------- */

  document.addEventListener('click', function (e) {
    var poster = e.target.closest('[data-video-poster]');
    if (!poster) return;
    var wrap = poster.closest('.video-wrap');
    var src = wrap.getAttribute('data-video-src');
    if (!src) return;
    var iframe = document.createElement('iframe');
    iframe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('title', wrap.getAttribute('data-video-title') || 'Video');
    wrap.appendChild(iframe);
    poster.remove();
  });
})();
